"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.unaryExpressionNode = void 0;
const common_1 = require("@finley-technologies/common");
exports.unaryExpressionNode = {
    hasChildNodes: true,
    getEvaluatorFunction: ({ node, buildContext }) => {
        // Functions definitions are retrieved from function stack at time of build
        const childNode = buildContext.functionStack.pop();
        (0, common_1.finleyAssert)(childNode, 'Unable to generate formula');
        let negative = false;
        switch (node.operator) {
            case '+':
                break;
            case '-':
                negative = true;
                break;
            default:
                (0, common_1.finleyAssertUnreachable)(node.operator);
        }
        return (evaluatorInput) => {
            const childNodeEvaluation = childNode.evaluatorFunction(evaluatorInput);
            if (childNodeEvaluation.output.error !== null) {
                return {
                    node,
                    inputs: [childNodeEvaluation],
                    output: childNodeEvaluation.output,
                };
            }
            const operand = childNodeEvaluation.output.result;
            if (typeof operand !== 'number') {
                return {
                    node,
                    inputs: [childNodeEvaluation],
                    output: {
                        error: `Unary expression ${node.operator} is only supported on numbers, but received: ${operand}`,
                    },
                };
            }
            return {
                node,
                inputs: [childNodeEvaluation],
                output: { error: null, result: negative ? -1 * operand : operand },
            };
        };
    },
};
//# sourceMappingURL=unaryExpression.js.map